import { v4 } from "uuid";
import { appsignal } from "../config/appsignal";
import dispatchCustomEvent from "./dispatchCustomEvent";
import pathOf from "./pathOf";

// Kind and request path → the reference of the report already sent for them on this page, so a
// poll against a blocked endpoint reports once rather than on every tick.
const referencesSent = new Map();

// An allow-list: AppSignal gets these facts and never text from the response, since free text from
// someone else's page can name the person who hit it in ways no pattern reliably catches.
const tagsFor = (error, reference) => {
  const { kind, details } = error;
  const tags = {
    kind,
    reference,
    status: details.status,
    method: details.method,
    request_path: details.requestPath,
    content_type: details.contentType,
    vendor: details.vendor,
    request_id: details.requestId,
    email_domains: details.emailDomains.join(","),
    page_path: pathOf(window.location.href),
  };

  return Object.fromEntries(Object.entries(tags).filter(([, value]) => value !== ""));
};

// Sends the error to AppSignal, at most once per kind and request path per page, then announces
// it on the document as `request-problem` with the reference the user can quote.
export default function reportUnexpectedResponse(error, { silent = false } = {}) {
  const key = `${error.kind} ${error.details.requestPath}`;
  let reference = referencesSent.get(key);
  let tags = null;

  if (!reference) {
    reference = v4().slice(0, 8).toUpperCase();
    referencesSent.set(key, reference);
    tags = tagsFor(error, reference);
    appsignal.sendError(error, (span) => span.setTags(tags));
  }

  dispatchCustomEvent(document, "request-problem", true, false, {
    kind: error.kind,
    silent,
    reference,
    details: error.details,
    reported: tags,
  });
}
